import { Ids } from '../constants'

export const CardPaymentsE2E = {
  Users: { General: '134c1f4c-6ed4-4e9c-bc20-9faebcc582a3@mailslurp.biz' },
  Ids,
} as const
